import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, StarIcon } from 'lucide-react';
type Particle = {
  shape: 'heart' | 'star';
  color: string;
  x: number;
  y: number;
  size: number;
  rotate: number;
  delay: number;
};
const COLORS = ['#F4A9C0', '#C7B2EC', '#F3D86E', '#F6BE98'];
const COUNT = 14;

/** Előre kiszámolt, egyenletesen szétszórt részecskék — kifelé és kicsit felfelé repülnek. */
const particles: Particle[] = Array.from({
  length: COUNT
}, (_, i) => {
  const angle = i / COUNT * Math.PI * 2 + (i % 2 ? 0.22 : -0.12);
  const distance = 95 + i * 37 % 60;
  return {
    shape: i % 3 === 1 ? 'star' : 'heart',
    color: COLORS[i % COLORS.length],
    x: Math.cos(angle) * distance,
    y: Math.sin(angle) * distance - 55,
    size: 14 + i * 7 % 9,
    rotate: i * 53 % 70 - 35,
    delay: i % 5 * 0.03
  };
});

/** Egyszeri, finom ünneplő robbanás szívecskékkel és csillagokkal a kártya közepéből (~1,5 mp). */
export function CelebrationBurst() {
  return <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center overflow-visible" aria-hidden="true" data-id="element-48" data-mp="z2nkelurffx5">
      {particles.map((p, i) => {
      const Icon = p.shape === 'heart' ? HeartIcon : StarIcon;
      return <motion.span key={i} className="absolute" initial={{
        x: 0,
        y: 0,
        opacity: 0,
        scale: 0.6,
        rotate: 0
      }} animate={{
        x: p.x,
        y: [0, p.y * 0.85, p.y - 25],
        opacity: [0, 1, 1, 0],
        scale: [0.6, 1.1, 0.9],
        rotate: p.rotate
      }} transition={{
        duration: 1.5,
        delay: p.delay,
        ease: [0.23, 1, 0.32, 1],
        times: undefined
      }} data-id="element-49" data-mp="q1pokquh6epn" data-mpi={i}>
            <Icon style={{
          width: p.size,
          height: p.size,
          color: p.color
        }} className="fill-current drop-shadow-sm" strokeWidth={1.5} data-id="element-50" data-mp="140fmg8p4cif2" />
          </motion.span>;
    })}
    </div>;
}